// extracted by mini-css-extract-plugin
export default {"notesContainer":"ktSyii"};